import BannerCreateForm from "../../../components/DriverBanner/BannerCreate";
import BannerDetails from "../../../components/DriverBanner/BannerDetails";
import BannerTargetAudience from "../../../components/DriverBanner/BannerTargetAudience";
import MenuNames from "../../../constants/Menu/MenuNames.json";

import BannerList from "../../../views/DriverBanner/BannerList";

const DriverBannerRoutes = [
  {
    menuName: MenuNames.DRIVER_BANNER,
    path: "/banner",
    component: BannerList,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_BANNER,
    path: "/banner/details",
    component: BannerDetails,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_BANNER,
    path: "/banner/create",
    component: BannerCreateForm,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_BANNER,
    path: "/banner/target_audience",
    component: BannerTargetAudience,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_BANNER,
    path: "/banner/",
  },
];

export default DriverBannerRoutes;
